import React from "react"
import avatar from "avatar/vigo.svg"

const Vigo = (props) => <img src={avatar} className="avatar" {...props} />

export default Vigo
